export const DEMO_CALL_COPY = {
  title: "Schedule a 10-Min Demo Call",
  subtitle: "Pick a weekday and a 10-minute slot.",
  timeZoneLabel: "Time Zone",
  salesHours: "Sales hours are Monday–Friday, 10:00 AM–5:00 PM Sydney time.",
  selectDateHint: "Select a date to see available times.",
  pickTimeHint: "Select a 10-minute time.",
  fullNameLabel: "Full Name",
  fullNamePlaceholder: "Jane Smith",
  emailLabel: "Work Email",
  emailPlaceholder: "jane@company.com",
  mobileLabel: "Direct Mobile Number",
  mobilePlaceholder: "+1 555 010 0142",
  websiteLabel: "(Optional) Your Website Domain",
  websitePlaceholder: "example.com",
  submit: "Confirm 10-Min Demo",
  successTitle: "Demo time selected",
  successClose: "Close",
  closeLabel: "Close dialog",
  prevMonth: "Previous month",
  nextMonth: "Next month",
  calendarLabel: "Choose a date",
  slotListLabel: "Available 10-minute times",
  weekdays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  errors: {
    slot: "Choose a date and a 10-minute time.",
    name: "Enter your full name.",
    email: "Enter a valid work email.",
    mobile: "Enter a direct mobile number.",
    website: "Enter a valid website domain, or leave this blank.",
    submit: "We could not save this time. Try again.",
  },
};
